import { ComponentRef, Directive, DoCheck, ElementRef, OnDestroy } from '@angular/core';
import { AppendComponentService } from '../../services/append-component.service';
import { EllipsisComponent } from './ellipsis.component';

@Directive({
  selector: '[ellipsis]'
})
export class EllipsisDirective implements DoCheck, OnDestroy {
  private contentRef: ComponentRef<EllipsisComponent> = undefined;
  private get $element(): HTMLElement {
    return this.element?.nativeElement;
  }

  constructor(private element: ElementRef, private appendComponentService: AppendComponentService) {}

  ngDoCheck(): void {
    if (!this.$element) return;

    if (
      this.$element.clientWidth < this.$element.scrollWidth ||
      this.$element.clientHeight < this.$element.scrollHeight
    ) {
      return this.addEllipsis();
    }

    this.removeEllipsis();
  }
  ngOnDestroy(): void {
    this.removeEllipsis();
  }

  private addEllipsis() {
    if (this.contentRef) return;

    this.contentRef = this.appendComponentService.appendComponent(EllipsisComponent, this.$element);
  }

  private removeEllipsis() {
    if (!this.contentRef) return;

    this.appendComponentService.removeComponent(this.contentRef);
    this.contentRef = undefined;
  }
}
